import React from "react";

import { Button } from "shared/ui/Button";
import { Modal } from "shared/ui/Modal";

interface ConfirmDialogProps {
    open: boolean;
    title: string;
    description: React.ReactNode;
    confirmLabel: string;
    // danger — для необратимых действий (удаление); по умолчанию обычное подтверждение.
    tone?: "primary" | "danger";
    saving?: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export const ConfirmDialog = ({
    open,
    title,
    description,
    confirmLabel,
    tone = "danger",
    saving,
    onClose,
    onConfirm,
}: ConfirmDialogProps) => (
    <Modal
        open={open}
        onClose={onClose}
        title={title}
        maxWidth="xs"
        actions={
            <>
                <Button variant="outlined" color="neutral" disabled={saving} onClick={onClose}>
                    Отмена
                </Button>
                <Button
                    variant="contained"
                    color={tone === "danger" ? "danger" : "primary"}
                    disabled={saving}
                    onClick={onConfirm}
                >
                    {confirmLabel}
                </Button>
            </>
        }
    >
        {description}
    </Modal>
);
